import React from 'react';
import { motion } from 'framer-motion';
import { Globe2, Zap, ShieldCheck } from 'lucide-react';
import { Card } from './ui/Card';
import { useLanguage } from '../hooks/useLanguage';
export function BenefitsSection() {
  const {
    t
  } = useLanguage();
  const benefits = [{
    icon: Globe2,
    title: t('benefits_1_title'),
    description: t('benefits_1_desc')
  }, {
    icon: ShieldCheck,
    title: t('benefits_2_title'),
    description: t('benefits_2_desc')
  }, {
    icon: Zap,
    title: t('benefits_3_title'),
    description: t('benefits_3_desc')
  }];
  return <section className="py-24 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4">
            {t('benefits_h2_before')}{' '}
            <span className="text-[#D4A843]" data-id="element-5">CV Go</span>
            {t('benefits_h2_after')}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-6">
          {benefits.map((benefit, index) => <Card key={index} className="group hover:bg-white/5 transition-colors duration-300" data-id="element-7">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} data-id="element-8">
                <div className="w-14 h-14 rounded-xl bg-[#D4A843]/10 flex items-center justify-center text-[#D4A843] mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-9">
                  <benefit.icon className="w-7 h-7" data-id="element-10" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-11">
                  {benefit.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-12">
                  {benefit.description}
                </p>
              </motion.div>
            </Card>)}
        </div>
      </div>
    </section>;
}